import { AxiosResponse } from 'axios';
import { IValidationApiResponse } from '../../../Services/FormikValidatorService';
import { getRequest } from '../../../Services/HttpService';

interface IAddressApiResponse {
  toast: any;
  prevRide: {
    timestamp: string;
    address: string;
    mileage: number;
  };
  nextRide: null | {
    address: string;
    timestamp: string;
  };
}

export const getDefaultDriver = async (vehicleId: string): Promise<number | null> => {
  const response: AxiosResponse | false = await getRequest(
    `/v2/vehicle/${vehicleId}/ride/form/defaultDriverId?vehicleId=${vehicleId}`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200 && response.data.id) {
    return response.data.id;
  }
  return null;
};

export const getValidation = async (vehicleId: number): Promise<IValidationApiResponse | null> => {
  const response: AxiosResponse | false = await getRequest(`/v2/vehicle/${vehicleId}/ride/validation`, { returnAxiosResponse: true });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};

export const getAddress = async (
  vehicleId: number,
  timestamp: string
): Promise<IAddressApiResponse | null> => {
  const response: AxiosResponse | false = await getRequest(
    `/v2/vehicle/${vehicleId}/ride/form/prefill?timestamp=${timestamp}`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};
